// Build-time configuration. Auth flows are visual-only in this build —
// "sign in" and "sign up" are wired to the page shells but don't talk
// to a backend yet. The OAuth buttons console.log their provider.

export const SITE_CONFIG = {
  name: "MemKernel",
  tagline: "The control plane for AI agents.",
  description:
    "Connect tools, MCP servers, memory, and identity once — expose them to Claude, Cursor, ChatGPT, or any agent runtime through a unified interface.",
  url: "https://memkernel.com",
  github: "https://github.com/cemsina/memkernel",
  twitter: "https://twitter.com/memkernel",
};

export const NAV_LINKS = [
  { label: "Product", href: "/#product" },
  { label: "Integrations", href: "/integrations" },
  { label: "Pricing", href: "/pricing" },
  { label: "Docs", href: "/docs" },
] as const;
